import React, { Component } from 'react'
import './subsubtask.css'

class SubSubTask extends Component {

    justDeleteIt = () => {
        let sub2xId = this.props.subsub.subtask2xId
        this.props.delete2xsub(sub2xId)
    }
    changeTheName = (theValue) => {
        let theSubSubId = this.props.subsub.subtask2xId
        this.props.changeSubSubName(theValue, theSubSubId)
    }
    autoReset = (theValue) => {
        let subsubId = 'subsubtask-name='+ this.props.subsub.subtask2xId
        if(theValue === 'New mini todo...') {
            document.getElementById(subsubId).value = ''
        }

    }
    render() {
        let subsubId = 'subsubtask-name='+ this.props.subsub.subtask2xId
        let subsubCheckmarkId = 'subsubtask-checkmark-' + this.props.subsub.subtask2xId
        return (
            <div>
                <div className="subsubtask">
                    <div className="subsub-checkmark" id={subsubCheckmarkId} onClick={() => this.justDeleteIt()}></div>
                    <input className="subsubtask-name" id={subsubId} value={this.props.subsub.subtask2xName} onClick={(e) => this.autoReset(e.target.value)} onChange={(e) => this.changeTheName(e.target.value)} />
                </div>
            </div>
        )
    }
}
export default SubSubTask